<div class="wrap client-hero">
  <h2 class="title">
    <span class="title-line">{{ name }}</span>
    <span class="title-line">{{ title }}</span>
  </h2>
  <div class="img-container">
    <img class="img" [src]="image" alt="client" />
  </div>
</div>
